import { useContext, useState, useCallback } from 'react';

import DocumentContext from '../../../../contexts/DocumentContext.context';
import ToolbarToggleButton from '../ToolbarToggleButton';

const InvisibleCharactersButton = () => {
  const { editor } = useContext(DocumentContext);
  /**
   * We unfortunately cannot rely on the `useEditorActive` hook in `ToolbarToggleButton`
   * because the content is not updated on toggling invisible characters.
   */
  const [on, setOn] = useState(false);

  const toggle = useCallback(() => {
    editor.chain().focus().toggleInvisibleCharacters().run();
    // read back from storage to reflect the real source of truth
    const current = Boolean(editor.storage.invisibleCharacters?.visibility?.());
    setOn(current);
  }, [editor]);

  return (
    <ToolbarToggleButton
      selector={on}
      worksWhenLocked
      tooltip={on ? 'Hide formatting marks' : 'Show formatting marks'}
      icon={
        <svg height="100%" width="100%" viewBox="0,0,2048,2048" focusable="false">
          <path
            type="path"
            style={{ fill: '#3A3A38FF' }}
            d="M1024 1126h-102q-111 0-207-56-93-54-147-146-56-95-56-207 0-111 56-207 54-93 147-147 95-56 207-56h460q21 0 37 15 15 15 15 36 0 21-15 37-15 15-37 15h-51v1382q0 21-15 36-15 15-36 15-21 0-36-15-15-15-15-36v-1382h-103v1382q0 21-15 36-15 15-36 15-21 0-36-15-15-15-15-36v-666z m-410-409q0 127 90 217 90 90 218 90h102v-614h-102q-127 0-218 90-90 90-90 217z"
          ></path>
        </svg>
      }
      onClick={toggle}
    />
  );
};

export default InvisibleCharactersButton;
